import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';
import { Button, Icons } from '../base/BootstrapComponents/BootstrapComponents';
import {
  smevCheckFormatter, localeFormatter, applicationStatusOperation,
} from '../../utils/formatters';
import { CHECK_STATUS_LIST } from '../../configs';

export default function MobileLayoutSubMenu({ onHide = () => {} }) {
  const location = useLocation();
  const isApplication = location.pathname.includes('application');
  const isRegistry = location.pathname.includes('region-registry');
  const navigate = useNavigate();
  return (
    <div className={classNames('helper-tooltip', { extension: isApplication || isRegistry })}>
      <div className="pmh-block">
        <div className="pmh-title">
          Меню пользователя
          <div className="pmh-title-close" onClick={onHide}>
            <Icons icon="close" customIcon />
          </div>
        </div>
        <div className="pmh-table">
          <div className="pmh-column">
            <Button className="mini-profile-menu-button" onClick={() => navigate('/notification')}>
              <Icons customIcon className="menu-item-icon" icon="notification" /> Уведомления
            </Button>
            <Button className="mini-profile-menu-button" onClick={() => window.keycloak.login({ action: 'UPDATE_PASSWORD' })}>
              <Icons customIcon className="menu-item-icon" icon="edit-password" /> Изменить пароль
            </Button>
            <Button className="mini-profile-menu-button" onClick={() => navigate('/logout')}>
              <Icons customIcon className="menu-item-icon" icon="exit" /> Выход
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
